import React from 'react'
import PanelHead from '../../UI/Panel/PanelHead';
import PanelBody from '../../UI/Panel/PanelBody';
import {EmailProvidersTable} from "../../UI/EmailProviders/EmailProvidersTable";

const EmailProvidersPage = () => {
  return (
    <div>
      <PanelHead title="Email Providers" />
      <PanelBody content={<EmailProvidersTable />} />
    </div>
  )
}

export default EmailProvidersPage;